<template lang="pug">
    include ../../media/pug/mixins.pug
    +b.services-list(
        name="services-list"
    )
        +e.H2.title.title._size_md._theme_secondary(v-if='isMobile') {{ $t('SERVICES_SIMPLE') }}
        rsl-services(
            v-bind:class="{'rsl-services_mobile' : isMobile}"
            v-bind:servicesList="list"
        )

</template>

<script>

import { mapGetters } from 'vuex';
import RslServices from '@RSL/RslServices/RslServices';

export default {
    components: {
        RslServices
    },
    data() {
        return {
            list: [
                {
                    title: 'Российская государственная библиотека',
                    icon: '/sprite.svg#logo-mobile-viewer',
                    href: 'https://rsl.ru/'
                },
                {
                    title: 'Поисковая система РГБ',
                    icon: '/sprite.svg#search-menu',
                    href: 'https://rsl.ru/'
                },
                {
                    title: 'Защищенная система просмотра документов',
                    icon: '/sprite.svg#lock',
                    href: 'https://rsl.ru/'
                },
                {
                    title: 'Система просмотра документов',
                    icon: '/sprite.svg#viewer',
                    href: 'https://rsl.ru/'
                },
                {
                    title: 'Электронная библиотека',
                    icon: '/sprite.svg#elibrory',
                    href: 'https://rsl.ru/'
                },
                {
                    title: 'Обязательная электронная копия',
                    icon: '/sprite.svg#copy',
                    href: 'https://rsl.ru/'
                },
                {
                    title: 'Паспорт РГБ',
                    icon: '/sprite.svg#passport',
                    href: 'https://rsl.ru/'
                },
                {
                    title: 'Избранные документы',
                    icon: '/sprite.svg#favorite',
                    href: 'https://rsl.ru/'
                },
                {
                    title: 'Обменный фонд РГБ',
                    icon: '/sprite.svg#exchange',
                    href: 'https://rsl.ru/'
                },
                {
                    title: 'Виртуальные выставки',
                    icon: '/sprite.svg#gallery',
                    href: 'https://rsl.ru/'
                }
            ]
        };
    },
    computed: {
        ...mapGetters([
            'isMobile'
        ])
    }
};
</script>
